// components
import {showToastCustom} from "../../../components/toast/customToast";

// actions
import { setLoading } from "../generalActions/mainActions";
import { addItem, changeListItem, removeItem, setItems, setTableParams } from "../generalActions/listActions";
import { setForm } from "../generalActions/formActions";

// labels
import { deleteErrorMsg, error } from "../../../components/i18n/i18n";

// utils
import { utilHelper } from "../../../jwt/_helpers";

// store
import { store } from "../../store";

/**
 * `genericActions` es un objeto que contiene métodos para manejar operaciones CRUD comunes.
 * Cada método despacha acciones al almacen Redux para manejar el estado de la aplicación.
 * @namespace genericActions
 */
export const genericActions = {
    /**
     * Busca elementos basado en el filtro proporcionado.
     * Despacha acciones para establecer el estado de carga, actualizar elementos y parámetros de la tabla en el almacen.
     * @function search
     * @memberof genericActions
     * @param {Object} provider - El proveedor a usar para la operación de búsqueda.
     * @param {number} pageIndex - El índice de la página a recuperar.
     * @param {number} pageSize - El número de elementos por página.
     * @param {Object} filter - Los criterios de filtro.
     */
    search : (provider, pageIndex, pageSize, filter) => {
        store.dispatch(setLoading(true))

        provider.search(pageIndex, pageSize, filter)
            .then(result => {
                if (!result)
                    return

                store.dispatch(setItems(result.data))
                store.dispatch(setTableParams(pageSize, pageIndex, (result?.filtered !== pageSize ? result?.filtered : result?.total) ))
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.log("Error",error)
            })
            .finally(() => store.dispatch(setLoading(false)))
    },

    /**
     * Guarda un nuevo elemento.
     * Despacha acciones para establecer el estado de carga, actualizar el estado del formulario y agregar el nuevo elemento al almacen.
     * @function save
     * @memberof genericActions
     * @param {Object} provider - El proveedor a usar para la operación de guardar.
     * @param {Object} data - Los datos del elemento a guardar.
     */
    save: (provider, data) => {
        store.dispatch(setLoading(true))

        provider.saveItem(data)
            .then(result => {
                store.dispatch( setForm(false, true, true) )
                if(result)
                    store.dispatch( addItem(result) )
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.log("Error",error)
            })
            .finally(() => store.dispatch(setLoading(false)))

    },

    /**
     * Actualiza un elemento existente.
     * Despacha acciones para establecer el estado de carga, actualizar el estado del formulario y cambiar el elemento en el almacen.
     * @function update
     * @memberof genericActions
     * @param {Object} provider - El proveedor a usar para la operación de actualización.
     * @param {string|number} id - El id del elemento a actualizar.
     * @param {Object} data - Los nuevos datos para el elemento.
     */
    update : (provider, id, data) => {
        store.dispatch(setLoading(true))

        provider.updateItem(id, data)
            .then(result => {
                store.dispatch( setForm(false, true, true) )
                if (result)
                    store.dispatch( changeListItem(result) )
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.log("Error",error)
            })
            .finally(() => store.dispatch(setLoading(false)))
    },

    /**
     * Elimina un elemento existente.
     * Despacha acciones para establecer el estado de carga y eliminar el elemento del almacen.
     * @function remove
     * @memberof genericActions
     * @param {Object} provider - El proveedor a usar para la operación de eliminación.
     * @param {string|number} id - El id del elemento a eliminar.
     * @param {Object} db - La base de datos para eliminar el elemento.
     */
    remove: (provider, id, db) => {
        store.dispatch(setLoading(true))

        provider.deleteItem(id, db)
            .then(result => {
                if(result?.status)
                    store.dispatch( removeItem(id) )

                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                }
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.log("Error",error)
            })
            .finally(() => store.dispatch(setLoading(false)))
    },

    removeFromFirebase: (provider, data) => {
        store.dispatch(setLoading(true))

        provider.removeFromFirebase(data)
            .then(result => {
                console.log("sin path",{result})
                if(result?.status)
                    store.dispatch( removeItem(result.id) )
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.log("Error",error)
            })
            .finally(() => store.dispatch(setLoading(false)))
    },
    translate: (provider, id, data, callBack = ()=> console.info('With out callback')) => {
        provider.translate(id, data)
            .then(result => {
                store.dispatch( setForm(false, true, true) )
                if (result?.status)
                    store.dispatch(changeListItem(result?.data))
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.error( "Error: ",errorMessage)
            })
            .finally(() => {
                callBack()
            })
    },
    get:(provider, id, fbDatabase = null, callBack = ()=>{}) => {
        store.dispatch(setLoading(true))

        provider.get(id, fbDatabase)
            .then(result => {
                if (!result)
                    return

                store.dispatch(setForm(true, false, false, result))
                callBack(result)
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
                console.error( "Error: ",errorMessage)
            })
            .finally(() => store.dispatch(setLoading(false)))
    }
}